import { render, staticRenderFns } from "./Projekter.vue?vue&type=template&id=587cb957&"
import script from "./Projekter.vue?vue&type=script&lang=js&"
export * from "./Projekter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports